import { baseClient } from '@/shared/api/baseClient';

type RefreshTokenParams = {
  refreshToken?: string;
};

type RefreshToken = {
  access_token: string;
  refresh_token: string;
  token_type: string;
};

export const refreshTokenAsync = async (params?: RefreshTokenParams) => {
  const response = await baseClient.post<RefreshToken>('/auth/token/refresh', {
    refresh_token: params?.refreshToken,
  });
  return response.data;
};
